import * as React from "react";

function SvgIcons8AndroidOs(props, ref) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...{ ...props, ref }}>
      <path d="M10.531 3.5a.5.5 0 00-.25.813l1.469 2.125A7.017 7.017 0 009 12v10c0 .703.441 1.203 1 1.563V26.5c0 1.367 1.133 2.5 2.5 2.5s2.5-1.133 2.5-2.5V24h2v2.5c0 1.367 1.133 2.5 2.5 2.5s2.5-1.133 2.5-2.5v-2.938c.559-.359 1-.859 1-1.562V12a7.017 7.017 0 00-2.75-5.563l1.469-2.125a.501.501 0 00-.406-.813.376.376 0 00-.094.001.5.5 0 00-.313.25l-1.5 2.125A6.98 6.98 0 0016 5a6.98 6.98 0 00-3.406.875l-1.5-2.125a.497.497 0 00-.406-.25.376.376 0 00-.094 0h-.063zM16 7a5.001 5.001 0 014.906 4h-9.812c.465-2.285 2.48-4 4.906-4zm-2 1c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM6 11v10h2V11zm18 0v10h2V11zm-13 2h10v9h-1v4.5c0 .285-.215.5-.5.5a.489.489 0 01-.5-.5V22h-6v4.5c0 .285-.215.5-.5.5a.489.489 0 01-.5-.5V22h-1z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8AndroidOs);
